export default "__VITE_ASSET__CvlXfu8p__"